import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import SignupPage from '../SignupPage';
import AuthCallback from '../AuthCallback';
import InviteCodePage from '../InviteCodePage';
import InviteRequiredPage from '../InviteRequiredPage';

/**
 * Auth Routes - Authentication and signup flows
 */

export function SignupPageRoute() {
    const navigate = useNavigate();
    const location = useLocation();
    const ref = new URLSearchParams(location.search).get('ref');
    const [hasInviteCode, setHasInviteCode] = useState(false);
    const [isChecking, setIsChecking] = useState(true);

    // Check if user has a valid invite code in session
    useEffect(() => {
        const code = sessionStorage.getItem('validInviteCode');
        if (!code) {
            navigate('/invite');
        } else {
            setHasInviteCode(true);
        }
        setIsChecking(false);
    }, [navigate]);

    // Show nothing while checking
    if (isChecking || !hasInviteCode) {
        return null;
    }

    return (
        <SignupPage
            onBack={() => navigate('/invite')}
            onSwitchToLogin={() => navigate('/login')}
            onSuccess={() => navigate('/dashboard')}
        />
    );
}

export function AuthCallbackRoute() {
    const navigate = useNavigate();
    return (
        <AuthCallback
            onSuccess={() => navigate('/dashboard')}
            onError={() => navigate('/login')}
        />
    );
}

export function InviteCodePageRoute() {
    const navigate = useNavigate();
    return (
        <InviteCodePage
            onValidCode={(code, codeData) => {
                // Store code for signup
                sessionStorage.setItem('validInviteCode', code);
                if (codeData) {
                    sessionStorage.setItem('inviteCodeData', JSON.stringify(codeData));
                }
                navigate('/signup');
            }}
            onBack={() => navigate('/')}
            onLearnMore={() => navigate('/beta')}
        />
    );
}

export function InviteRequiredPageRoute() {
    const navigate = useNavigate();
    return (
        <InviteRequiredPage
            onBack={() => navigate('/login')}
            onHaveCode={() => navigate('/invite')}
            onLearnMore={() => navigate('/beta')}
        />
    );
}
